/** Шаги установки на iPhone — подходят и к новому Safari (•••), и к старому (⬆). */
export const IOS_INSTALL_STEPS = [
  "Нажми ••• внизу справа (или значок со стрелкой)",
  "Выбери «Поделиться»",
  "Пролистай вниз и нажми «На экран „Домой“»",
  "Нажми «Добавить»",
];

export function IosInstallSteps({ className = "text-base text-td-dark" }: { className?: string }) {
  return (
    <ol className={`space-y-3 ${className}`}>
      {IOS_INSTALL_STEPS.map((s, i) => (
        <li key={s} className="flex items-start gap-3">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-td-teal text-base font-bold text-white">
            {i + 1}
          </span>
          <span className="pt-1 text-lg font-medium">
            <span className="text-td-muted">Шаг {i + 1}. </span>
            {s}
          </span>
        </li>
      ))}
    </ol>
  );
}
